import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// get all job cards (default list load)
export const getJobCardList = createAsyncThunk(
  "jobCard/getAllFinalJobCard",
  async (data = {}, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const payload = {
        page: String(data.page || 1),
        size: String(data.size || 300),
        search: data.search || [],
      };

      const response = await axios.post(
        `${baseUrl}finalJobCard/api/v1/getAllFinalJobCard`,
        payload,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Job card res", response);
      return response;
    } catch (error) {
      console.error("Error fetching job cards:", error);
      return rejectWithValue(error.response?.data?.message || "Failed to fetch job cards");
    }
  }
);

// search job cards (search drawer)
export const searchJobCardList = createAsyncThunk(
  "jobCard/search",
  async ({ page = 1, size = 100, search = [] }, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const payload = {
        page: String(page),
        size: String(size),
        search, // 👈 array of { field, operation, value } - send as-is, no transform
      };

      const response = await axios.post(
        `${baseUrl}finalJobCard/api/v1/getAllFinalJobCard`,
        payload,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error searching job cards:", error);
      return rejectWithValue(error.response?.data?.message || "Search Failed");
    }
  }
);